<template>
	<div class="one_01">
		<router-tab append="last" :keep-last-tab="false" restore="false" icon="el-icon-menu" />
	</div>
</template>

<script>
export default {
	data() {
		return {
		};
	},
	components: {
	},

	mounted() {
	},

	methods: {
		// 回到控制台
		clickHome() {
			this.$router.push({
				path: '/exeIndex/mainIndex/workbench'
			})
		},
		// 后退
		clickBack() {
			this.$router.go(-1)
		},

		// 前进
		clickNext() {
			this.$router.go(1)
		},

		// 刷新
		clickRefresh() {
			this.$router.go(0)
		}

	}
}
</script>


<style scoped>
.home-container {
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	display: flex;
	background: #FFFFFF;
}

.one_01 {
	width: 100%;
	height: 100%;
	background: #e7e7e7;
	position: relative;
	overflow: visible;
}
/* 优化tab项的样式，减少布局变化 */
::v-deep .router-tab__item {
  margin-top: 5px;
  transition: all 0.2s ease;
}
</style>